module.exports = __webpack_public_path__ + "img/ic_alert_expire.5644149b.png";